import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M12 9h8v4h1V8.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V13h1V9"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14 11a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4M23.5 14h-15a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5H11v1.5c0 2.06-1.559 2.498-1.621 2.515a.5.5 0 1 0 .243.97C10.444 23.779 12 22.786 12 20.5V19h2v2.5c0 1.149-.7 1.54-.724 1.553a.5.5 0 0 0 .447.894C13.776 23.921 15 23.288 15 21.5V19h2v2.5c0 1.788 1.225 2.421 1.276 2.447a.5.5 0 0 0 .454-.891c-.03-.016-.73-.407-.73-1.556V19h2v1.5c0 2.286 1.556 3.279 2.379 3.485a.498.498 0 0 0 .606-.364.5.5 0 0 0-.364-.606C22.605 23.011 21 22.586 21 20.5V19h2.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5m-.5 4H9v-3h14v3"
      })]
    })
  }));
};
export default SvgComponent;